import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MailValidationComponent } from './components/mail-validation/mail-validation.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { RequestPasswordResetComponent } from './components/request-password-reset/request-password-reset.component';
import { SignInAcComponent } from './components/sign-in-ac/sign-in-ac.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { AuthComponent } from './pages/auth/auth.component';
import { DinamicSignupComponent } from './components/dinamic-signup/dinamic-signup.component';
import { SignupAbandonoGuard } from 'src/app/shared/guards/signup-abandono.guard';
const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,

    children: [
      { path: 'login', component: SignInComponent },
      {
        path: 'signup',
        component: DinamicSignupComponent,
        // Confirma antes de salir si hay capturas sin subir (pasos 5-10 de
        // empresa). Ver SignupAbandonoGuard.
        canDeactivate: [SignupAbandonoGuard],
      },
      { path: 'complete-password-reset', component: PasswordResetComponent },
      {
        path: 'request-password-reset',
        component: RequestPasswordResetComponent,
      },
      {
        path: 'confirm-mail-verification/:email/:code',
        component: MailValidationComponent,
      },
      { path: 'ac', component: SignInAcComponent },
      { path: 'new-signup', component: DinamicSignupComponent },
      { path: 'retail-signup', component: DinamicSignupComponent },
      { path: 'dinamic-signup', component: DinamicSignupComponent },
      {
        path: 'retail-password-reset',
        component: RequestPasswordResetComponent,
      },
      {
        path: 'retail-complete-password-reset',
        component: PasswordResetComponent,
      },
      { path: '**', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
